import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AddDaysToDateString } from 'src/app/product-capture/utils/add-days-to-date-string';
import { AddMonthsToDateString } from 'src/app/product-capture/utils/add-months-to-date-string';
import { AddYearsToDateString } from 'src/app/product-capture/utils/add-years-to-date-string';
import { GetDateObjectToFullIsoString } from 'src/app/product-capture/utils/get-data-object-to-full-ISO-string';
import { GetDaysApartCount } from 'src/app/product-capture/utils/get-days-apart-count';
import { TenorSplitter } from 'src/app/product-capture/utils/tenor-splitter';

export function issuePlusTenorEqualsMaturity(
  issueDate: any,
  tenor: string,
  redemptionDate: any,
  mainForm: boolean // We use this validator twice (true = main form / false = key dates modal).
  // The distinction is important because the control paths are different in each case.
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let issueDateControl: AbstractControl;
    let tenorControl: AbstractControl;
    let redemptionDateControl: AbstractControl;

    if (mainForm) {
      issueDateControl = control.get('keyDates').get(issueDate).get('value');
      tenorControl = control.get(tenor);
      redemptionDateControl = control
        .get('keyDates')
        .get(redemptionDate)
        .get('value');
    }

    if (!mainForm) {
      issueDateControl = control.get(issueDate).get('issueDateDate');
      tenorControl = control.get(tenor);
      redemptionDateControl = control
        .get('redemptionDateGroup')
        .get(redemptionDate);
    }

    const issueDateStr = GetDateObjectToFullIsoString(issueDateControl.value);
    const redemptionDateStr = GetDateObjectToFullIsoString(
      redemptionDateControl.value
    );
    const tenorArr = TenorSplitter(tenorControl.value);

    // We run the validator only if there are valid values for the three inputs. If an input is invalid
    // each of the three functions above would return a null and we wouldn't enter the below block.
    // We run different functions to add time dependant on whether tenor is in days, months or years.
    if (issueDateStr && redemptionDateStr && tenorArr) {
      const [tenorNumber, tenorValue] = tenorArr;

      if (tenorValue === 'D') {
        const issueDatePlusTenor = AddDaysToDateString(
          issueDateStr,
          tenorNumber
        );
        const diffWithMaturityDate = GetDaysApartCount(
          issueDatePlusTenor,
          redemptionDateStr
        );

        if (diffWithMaturityDate > 20) {
          redemptionDateControl.setErrors({
            incorrect: true,
            message: 'Redemption Date must equal Issue Date + Tenor',
          });
        } else {
          redemptionDateControl.setErrors(null);
        }
      }

      if (tenorValue === 'W') {
        const issueDatePlusTenor = AddDaysToDateString(
          issueDateStr,
          tenorNumber * 7
        );

        const diffWithMaturityDate = GetDaysApartCount(
          issueDatePlusTenor,
          redemptionDateStr
        );

        if (diffWithMaturityDate > 20) {
          redemptionDateControl.setErrors({
            incorrect: true,
            message: 'Redemption Date must equal Issue Date + Tenor',
          });
        } else {
          redemptionDateControl.setErrors(null);
        }
      }

      if (tenorValue === 'M') {
        const issueDatePlusTenor = AddMonthsToDateString(
          issueDateStr,
          tenorNumber
        );
        const diffWithMaturityDate = GetDaysApartCount(
          issueDatePlusTenor,
          redemptionDateStr
        );
        if (diffWithMaturityDate > 20) {
          redemptionDateControl.setErrors({
            incorrect: true,
            message: 'Redemption Date must equal Issue Date + Tenor',
          });
        } else {
          redemptionDateControl.setErrors(null);
        }
      }

      if (tenorValue === 'Y') {
        const issueDatePlusTenor = AddYearsToDateString(
          issueDateStr,
          tenorNumber
        );
        const diffWithMaturityDate = GetDaysApartCount(
          issueDatePlusTenor,
          redemptionDateStr
        );
        if (diffWithMaturityDate > 20) {
          redemptionDateControl.setErrors({
            incorrect: true,
            message: 'Redemption Date must equal Issue Date + Tenor',
          });
        } else {
          redemptionDateControl.setErrors(null);
        }
      }
    }

    return null;
  };
}
